import { z } from 'zod';

export const SHAPES = ['rectangular', 'half_moon', 'oval', 'custom'];
export const COLORS = ['natural', 'black', 'red', 'yellow', 'green', 'custom'];
export const FLAVORS = [
  'natural',
  'gingerbread',
  'poppy_seed',
  'cumin',
  'fennel',
  'blackcurrant',
  'turmeric_black_pepper',
  'custom',
];

const sizeOneDecimal = z
  .number()
  .min(1)
  .max(30)
  .refine((n) => Number.isInteger(n * 10), {
    message: 'max 1 decimal',
  });

export const orderSchema = z.object({
  customerName: z.string().trim().min(3).max(120),
  phoneNumber: z.string().trim().min(3).max(40),
  company: z.string().trim().min(3).max(120),
  email: z.string().trim().email().max(240),
  address: z.string().trim().min(3).max(240),

  quantity: z.number().int().min(1),
  shape: z.enum(SHAPES),
  size: sizeOneDecimal,
  color: z.enum(COLORS),
  flavor: z.enum(FLAVORS),

  message: z.string().max(2000).optional().default(''),

  website: z.literal(''),
  cfTurnstileToken: z.string().min(1),
});
